module.exports = __webpack_public_path__ + "img/about-children-bg-2@dt.f7777d0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-children-bg-2@dt.svg
// module id = mrrp
// module chunks = 2